import morphism, { createSchema } from 'morphism';

const collectionResponseSchema = createSchema(
  {
    tags: 'tags',
    id: '_id',
    isPublic: 'isPublic',
    name: 'name',
    products: 'products',
    updatedAt: 'updatedAt',
    createdAt: 'createdAt',
    deleted: 'deleted'
  },
  { undefinedValues: { strip: true } }
);

export default {
  collection: createSchema(collectionResponseSchema, { undefinedValues: { strip: true } }),
  list: createSchema(
    {
      docs: source => morphism(collectionResponseSchema, source.docs),
      pagination: {
        limit: 'limit',
        page: 'page',
        pages: 'totalPages',
        total: 'totalDocs'
      }
    },
    { undefinedValues: { strip: true } }
  )
};
